// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2ETrI","buttons":"SendReceipts_buttons__2sAqG","email":"SendReceipts_email__1_aU5","bookApptTitle":"SendReceipts_bookApptTitle__2DyYX"};